import { render } from "./PlaygroundURL.vue?vue&type=template&id=0393782f&scoped=true"
import script from "./PlaygroundURL.vue?vue&type=script&lang=js"
export * from "./PlaygroundURL.vue?vue&type=script&lang=js"

import "./PlaygroundURL.vue?vue&type=style&index=0&id=0393782f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0393782f"]])

export default __exports__